import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M0 0h24v24H0V0Zm1 1v21.5c.12 0 .22-.04.35-.2.14-.18.28-.46.4-.86.2-.6.34-1.34.49-2.15.05-.29.1-.59.17-.89.22-1.12.51-2.32 1.02-3.24.45-.8 1.1-1.45 2.07-1.62V7.5h13v1.93c.5-.14.88-.51 1.2-1.08.42-.77.68-1.82.91-2.95l.16-.82c.15-.83.31-1.66.52-2.33A3.65 3.65 0 0 1 21.93 1H1Zm17.5 9.46v6.04h-13v-1.93c-.5.14-.88.51-1.2 1.08-.42.77-.68 1.82-.91 2.95l-.16.82c-.15.83-.31 1.66-.52 2.33A3.65 3.65 0 0 1 2.07 23H23V1.5c-.12 0-.22.04-.35.2a2.7 2.7 0 0 0-.4.86c-.2.6-.34 1.34-.49 2.15-.05.29-.1.59-.17.89a11.56 11.56 0 0 1-1.02 3.24c-.45.8-1.1 1.45-2.07 1.62ZM6.5 8.5v7h11v-7h-11Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }